<ng-template #resultadoNaoEncontrado>
  <article class="col-12 aviso-sem-resultado">
    <!-- <p class="content__resultado__aviso__conteudo">        
        Nenhum resultado encontrado.
      </p> -->
    <p>
      Nenhum resultado encontrado.
    </p>
  </article>
</ng-template>
<div class="col-12" id="credenciados" *ngIf="lista?.totalFiltered > 0 else resultadoNaoEncontrado">
  <div class="collapse show" aria-labelledby="headingOne" data-parent="#accordion">
    <div class="card-body-legendas">
      <section class="content-resultado mt-3">
        <div *ngFor="let credenciado of lista.items;">
          <section class="d-flex card-content-credenciado">
            <div class="col-sm-12 col-lg-10 col-xl-10 pl-0 pr-0">
              <div class="d-flex flex-column pl-2">
                <span *ngIf="!isMobile && !isTablet">
                  <b class="title-color">
                    {{credenciado?.tradeName}} - ({{credenciado?.codPrestador}})
                  </b>
                </span>
                <div class="col-12 d-flex content-mobile-header" *ngIf="isMobile || isTablet">
                  <div class="col-9">
                    <span>
                      <b class="title-color">
                        {{credenciado?.tradeName}} - ({{credenciado?.codPrestador}})
                      </b>
                    </span>
                    <br>
                    <span>
                      <b class="subtitle-color">
                        {{credenciado?.companyName}}
                      </b>
                    </span>
                  </div>
                  <div class="col-3">
                    <div class="content-mobile-icone">
                      <a class="card-icone-exclamacao" title="Ver mais Informações"
                        *ngIf="credenciado?.companyType != 'Hospital'" (click)="detalheEntidade(credenciado)">
                        <fa-icon [icon]="faCircleInfo" class="content__resultado__aviso__icone"></fa-icon>
                      </a>
                      <a class="card-icone-localizacao"
                        *ngIf="(credenciado?.neighborhood && credenciado?.city && credenciado?.state) else showNaoPossuiEnderecoMap"
                        (click)="google(
                            credenciado?.address,credenciado?.addressNumber,credenciado?.neighborhood,credenciado?.city,credenciado?.state)"
                        title="Localização">
                        <fa-icon [icon]="faLocationDot" class="content__resultado__aviso__icone"></fa-icon>
                      </a>
                      <ng-template #showNaoPossuiEnderecoMap>
                        <a title="Não Possui localização">
                          <img src="../../../../../assets/img/svg/pin-map.svg" class="icone-mapa-sem-localizacao">
                        </a>
                      </ng-template>
                    </div>
                  </div>
                </div>
                <div class="subtitle-color">
                  <span>{{credenciado?.companyName }}</span>
                </div>
                <div *ngIf="credenciado.crm">
                  <span>CRM: {{credenciado?.crm }}</span>
                </div>
                <div>
                  <span class="label-resultado">TIPO DE ESTABELECIMENTO: </span>
                  {{credenciado?.companyType }}
                </div>
                <div class="d-flex" *ngIf="credenciado?.expertize">
                  <div>
                    <span class="label-resultado">ESPECIALIDADES: </span>
                    <span class="label-resultado-especialidades">
                      {{credenciado?.expertize }};
                    </span>
                  </div>
                </div>
                <div *ngIf="credenciado?.site">
                  <span>SITE: </span>
                  {{credenciado.site}}
                </div>
                <div *ngIf="credenciado?.cnpj">
                  <span class="label-resultado">CNPJ: </span>
                  {{credenciado.cnpj }}
                </div>
                <div class="is-mobile-or-is-tablet">
                  <span *ngIf="credenciado?.phone">
                    <span class="label-resultado">TELEFONE 1: </span>
                    {{credenciado?.phone | Phone}}
                  </span>
                  <br *ngIf="credenciado.phone">
                  <span *ngIf="credenciado?.phone2">
                    <span>TELEFONE 2: </span>
                    {{credenciado?.phone2 }}
                  </span>
                  <span *ngIf="!credenciado?.phone2 && !credenciado?.phone">
                    <span>Telefone não localizado.</span>
                  </span>
                </div>
                <div>
                  <span class="label-resultado">PLANOS:</span>
                  <span> {{credenciado?.planos }}</span>
                </div>
              </div>
              <div class="pl-2 content-endereco"
                *ngIf="(credenciado?.address || credenciado?.addressnumber || credenciado?.neighborhood || credenciado?.city || credenciado?.state || credenciado?.cep) else showNaoPossuiEndereco">
                {{credenciado?.address | uppercase}}, {{credenciado?.addressNumber | uppercase}},
                {{credenciado?.neighborhood | uppercase}}, {{credenciado?.city | uppercase}}, {{credenciado?.state |
                uppercase}} - CEP {{credenciado?.cep }}
              </div>
              <ng-template #showNaoPossuiEndereco>
                <div class="pl-2 content-endereco">Endereço não informado </div>
              </ng-template>
            </div>
            <div class="col-sm-12 col-lg-2 col-xl-2 text-right content-telefone-icon not-is-mobile-or-not-is-tablet">
              <div>
                <span *ngIf="credenciado?.phone">{{credenciado?.phone | Phone}}</span>
                <br *ngIf="credenciado?.phone">
                <span *ngIf="credenciado?.phone2">{{credenciado?.phone2 | Phone}}</span>
                <span *ngIf="!credenciado?.phone2 && !credenciado?.phone">Telefone não localizado.</span>
              </div>
              <div>
                <div>
                  <a class="mr-2 botao-credenciado card-icone-exclamacao" title="Ver mais Informações"
                    *ngIf="credenciado?.companyType != 'Hospital'" (click)="detalheEntidade(credenciado)">
                    <fa-icon [icon]="faCircleInfo" class="icone-exclamacao"></fa-icon>
                  </a>
                  <a class="botao-credenciado card-icone-localizacao"
                    *ngIf="(credenciado?.neighborhood && credenciado?.city && credenciado?.state) else showNaoPossuiEnderecoMap"
                    (click)="google(
                        credenciado?.address,credenciado?.addressNumber,credenciado?.neighborhood,credenciado?.city,credenciado?.state)"
                    title="Localização">
                    <fa-icon [icon]="faLocationDot" class="icone-mapa"></fa-icon>
                  </a>
                  <ng-template #showNaoPossuiEnderecoMap>
                    <a title="Não Possui localização">
                      <img src="../../../../../assets/img/svg/pin-map.svg" class="icone-mapa-sem-localizacao">
                    </a>
                  </ng-template>
                </div>
              </div>
            </div>
          </section>
        </div>
      </section>
    </div>
  </div>
</div>
<footer class="mx-2" *ngIf="lista?.totalFiltered > 0">
  <paginacao [currentPage]="1" [collectionSize]="lista?.totalFiltered" [pageSize]="lista?.limit"
    (changeNumber)="onChangePagination($event)"></paginacao>
</footer>